// extracted by mini-css-extract-plugin
export default {"title":"PatternPage_title__xOre9","h1":"PatternPage_h1__s96Es"};